import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    grandTotal: "",
    total_Amount: 0
}

export const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {

        couponAmount: (state, action) => {
            state.grandTotal = action.payload
        },
        totalOrderAmount: (state, action) => {
            state.total_Amount = action.payload
        },

    },
})


export const { couponAmount, totalOrderAmount } = checkoutSlice.actions

export default checkoutSlice.reducer